export default {
  'nav.home': 'الرئيسية',
  'nav.feedback': 'الآراء',
  'nav.games': 'ألعاب',
  'nav.privacy': 'سياسة الخصوصية',
  'nav.menu': 'القائمة',
  'nav.scan': 'مسح رمز QR',
  'nav.about': 'عن بيولا',
  'nav.contact': 'تواصل معنا',
  'nav.locations': 'فروعنا',

  'lang.ar': 'عربي',
  'lang.en': 'English',

  'filter.glutenFree': 'خالي من الغلوتين',
  'filter.lactoseFree': 'خالي من اللاكتوز',
  'filter.vegetarian': 'نباتي',
  'filter.spicy': 'حار',
  'filter.sugarFree': 'خالي من السكر',
  'filter.vegan': 'نباتي صرف',

  'hero.badge': 'طازج \u2022 محلي \u2022 مصنوع بحب',
  'hero.title': 'BIOLA CAFE & RESTAURANT',
  'hero.subtitle': 'إفطار حرفي، أوعية صحية، معجنات مصنوعة يدويًا وحلويات لا تُقاوم \u2014 كلها طازجة يوميًا.',
  'hero.ctaMenu': 'استعرض القائمة',
  'hero.ctaAbout': 'قصتنا',
  'hero.ctaContact': 'تواصل معنا',
  'hero.ctaLocation': 'فروعنا',

  'menu.title': 'قائمتنا',
  'menu.subtitle': 'اكتشف تشكيلتنا المختارة من الأطباق المصنوعة يدويًا بأجود المكونات الطازجة.',
  'menu.searchPlaceholder': 'ابحث عن العنصر حسب الاسم أو السعر أو الوصف.',
  'menu.noItems': 'لم يتم العثور على عناصر',
  'menu.noItemsHint': 'جرّب تعديل البحث أو فلتر الفئة',
  'menu.allItems': 'جميع العناصر',
  'menu.currency': 'د.إ',
  'menu.detail': 'عرض التفاصيل',
  'menu.popular': 'الأكثر رواجًا',
  'menu.tapToClose': 'اضغط خارج النافذة للإغلاق',

  'view.grid': 'شبكة',
  'view.list': 'قائمة',

  'category.all': 'الكل',
  'category.hotDrinks': 'مشروبات ساخنة',
  'category.coldDrinks': 'مشروبات باردة',
  'category.sweets': 'حلويات',
  'category.food': 'أطعمة',
  'category.breakfast': 'فطور',

  'menuGroup.hotDrinks': 'مشروبات ساخنة',
  'menuGroup.coldDrinks': 'مشروبات باردة',
  'menuGroup.sweets': 'حلويات لذيذة',
  'menuGroup.food': 'أطبقة شهية',
  'menuGroup.breakfast': 'فطور',

  'item.1.name': 'سبانش كورتادو',
  'item.1.desc': 'جرعة إسبريسو ممزوجة بالحليب المكثف الدافئ لنكهة غنية وحلاوة خفيفة.',
  'item.2.name': 'سبانش لاتيه',
  'item.2.desc': 'إسبريسو ناعم مع الحليب المبخر والحليب المكثف لقهوة كريمية وحلوة.',
  'item.3.name': 'لاتيه',
  'item.3.desc': 'إسبريسو مغطى بحليب مبخر ناعم وطبقة خفيفة من الرغوة.',
  'item.4.name': 'كابتشينو',
  'item.4.desc': 'أجزاء متساوية من الإسبريسو والحليب المبخر والرغوة لقهوة كلاسيكية متوازنة.',
  'item.5.name': 'كورتادو',
  'item.5.desc': 'إسبريسو ممزوج بكمية صغيرة من الحليب الدافئ لطعم قوي وناعم.',
  'item.6.name': 'في 60',
  'item.6.desc': 'قهوة مقطرة يدويًا تُحضّر ببطء لكوب نقي وعطري.',
  'item.7.name': 'بيكولو',
  'item.7.desc': 'لاتيه صغير - جرعة إسبريسو واحدة مع حليب مبخر، تُقدّم في كوب صغير.',
  'item.8.name': 'إسبريسو',
  'item.8.desc': 'جرعة مركزة من قهوة غنية وقوية.',
  'item.9.name': 'شوكولاتة ساخنة',
  'item.9.desc': 'شوكولاتة ذائبة دافئة وكريمية، تُقدّم غنية ومريحة.',
  'item.10.name': 'ماتشا ساخنة',
  'item.10.desc': 'ماتشا فاخرة تُخفق مع حليب مبخر لمشروب دافئ ناعم بنكهة عشبية.',
  'item.11.name': 'أمريكانو',
  'item.11.desc': 'إسبريسو ممزوج بالماء الساخن لقهوة سوداء أخف وأكثر نعومة.',
  'item.12.name': 'سموذي الأساي',
  'item.12.desc': 'أساي مخلوط مع فواكه متنوعة لمشروب منعش وغني بمضادات الأكسدة.',
  'item.13.name': 'بيستاشيو مثلج',
  'item.13.desc': 'مشروب حليب بنكهة الفستق المثلج بطعم كريمي ومكسرات.',
  'item.14.name': 'موهيتو فاكهة الباشن',
  'item.14.desc': 'نعناع طازج وليمون ممزوج بفاكهة الباشن الحلوة والصودا.',
  'item.15.name': 'سبانش مثلج',
  'item.15.desc': 'إسبريسو مثلج مع الحليب المكثف على الثلج لقهوة باردة وحلوة.',
  'item.16.name': 'ماتشا مثلج',
  'item.16.desc': 'ماتشا مثلجة مخفوقة مع حليب بارد على الثلج.',
  'item.17.name': 'موهيتو فراولة',
  'item.17.desc': 'نعناع طازج وليمون مع فراولة مهروسة وصودا.',
  'item.18.name': 'موهيتو التوت الأزرق',
  'item.18.desc': 'نعناع طازج وليمون مع توت أزرق وصودا، منعش وحامضي قليلاً.',
  'item.19.name': 'موهيتو ليمون',
  'item.19.desc': 'موهيتو كلاسيكي بالنعناع والليمون، منعش وحامضي.',
  'item.20.name': 'ميلك شيك',
  'item.20.desc': 'ميلك شيك سميك وكريمي.',
  'item.21.name': 'كركديه',
  'item.21.desc': 'شاي الكركديه المثلج، حامضي ومنعش بشكل طبيعي.',
  'item.22.name': 'بيبسي',
  'item.22.desc': 'مشروب غازي كلاسيكي بارد.',
  'item.23.name': 'مونتن ديو',
  'item.23.desc': 'مشروب غازي بنكهة الحمضيات.',
  'item.24.name': 'كولا',
  'item.24.desc': 'مشروب غازي كلاسيكي بارد.',
  'item.25.name': 'ماء',
  'item.25.desc': 'مياه معبأة مثلجة.',
  'item.26.name': 'وعاء الأساي',
  'item.26.desc': 'أساي مخلوط مغطى بالغرانولا والفواكه الطازجة والعسل.',
  'item.27.name': 'كرواسون شوكولاتة',
  'item.27.desc': 'كرواسون زبداني مقرمش محشو بشوكولاتة داكنة غنية.',
  'item.28.name': 'بودينغ التمر',
  'item.28.desc': 'كيكة تمر إسفنجية دافئة مغموسة بصلصة الكراميل، تُقدّم مع آيس كريم الفانيليا.',
  'item.29.name': 'بودينغ الموز',
  'item.29.desc': 'طبقات من الكاسترد الكريمي بالفانيليا والموز والبسكويت.',
  'item.30.name': 'ميل فوي بالتوت المشكل',
  'item.30.desc': 'عجين مقرمش مطبق مع كريمة الحلويات والتوت الطازج المشكل.',
  'item.31.name': 'كيكة الشوكولاتة الذائبة',
  'item.31.desc': 'كيكة شوكولاتة دافئة بقلب ذائب طري، تُقدّم مع آيس كريم الفانيليا.',
  'item.32.name': 'تشيز كيك سان سيباستيان',
  'item.32.desc': 'تشيز كيك على الطريقة الباسكية، كريمي من الداخل مع سطح مكرمل.',
  'item.33.name': 'تشيز كيك',
  'item.33.desc': 'تشيز كيك كلاسيكي كريمي مخبوز على قاعدة بسكويت.',
  'item.34.name': 'ثلاثية تشيز كيك الشو',
  'item.34.desc': 'عجين الشو محشو بكريمة التشيز كيك، قطع صغيرة فاخرة.',
  'item.35.name': 'بودينغ الخبز',
  'item.35.desc': 'بودينغ خبز دافئ ومخبوز، مغموس بالكاسترد والتوابل.',
  'item.36.name': 'كوكيز كيندر',
  'item.36.desc': 'كوكيز طرية محشوة بشوكولاتة كيندر.',
  'item.37.name': 'كوكيز جالاكسي',
  'item.37.desc': 'كوكيز طرية محشوة بشوكولاتة جالاكسي.',
  'item.38.name': 'باستا ألفريدو',
  'item.38.desc': 'باستا مع صلصة ألفريدو الكريمية.',
  'item.39.name': 'باستا الصلصة الحمراء',
  'item.39.desc': 'باستا مع صلصة طماطم غنية.',
  'item.40.name': 'برجر دبل',
  'item.40.desc': 'قطعتان من اللحم المشوي العصاري مع الجبن وإضافات طازجة في خبز طري.',
  'item.41.name': 'برجر سنجل دجاج/لحم',
  'item.41.desc': 'قطعة دجاج أو لحم مشوية مع إضافات طازجة في خبز طري.',
  'item.42.name': 'قطع الدجاج واللحم',
  'item.42.desc': 'شرائح دجاج ولحم مشوية ومتبلة، تُقدّم معًا.',
  'item.43.name': 'توست دجاج',
  'item.43.desc': 'حشوة دجاج مشوي في خبز محمص.',
  'item.44.name': 'توست لحم',
  'item.44.desc': 'حشوة لحم مشوي في خبز محمص.',
  'item.45.name': 'بيولا سيجنتشر دجاج',
  'item.45.desc': 'ساندويتش الدجاج المميز الخاص بنا مع صلصتنا الخاصة.',
  'item.46.name': 'بيولا سيجنتشر لحم',
  'item.46.desc': 'ساندويتش اللحم المميز الخاص بنا مع صلصتنا الخاصة.',
  'item.47.name': 'بطاطس مع صلصة ودجاج',
  'item.47.desc': 'بطاطس مقرمشة مغطاة بالصلصة وقطع الدجاج المشوي.',
  'item.48.name': 'بطاطس مع صلصة',
  'item.48.desc': 'بطاطس مقرمشة مغطاة بصلصتنا الخاصة.',
  'item.49.name': 'بطاطس عادية',
  'item.49.desc': 'بطاطس ذهبية مقرمشة كلاسيكية.',
  'item.50.name': 'بريوش لبنة زعتر',
  'item.50.desc': 'خبز بريوش محمص مغطى بلبنة كريمية وزعتر وطماطم مشوية ببطء.',
  'item.51.name': 'كرواسون بيض وجبن',
  'item.51.desc': 'كرواسون مقرمش محشو ببيض مخفوق وجبن ذائب.',
  'item.52.name': 'شكشوكة',
  'item.52.desc': 'بيض مسلوق في صلصة طماطم غنية، يُقدّم مع خبز السمسم.',
  'item.53.name': 'كرواسون زعتر',
  'item.53.desc': 'كرواسون زبداني مغطى بالزعتر وزيت الزيتون.',
  'item.54.name': 'كرواسون سادة',
  'item.54.desc': 'كرواسون زبداني مقرمش كلاسيكي.',
  'item.55.name': 'كرواسون لوز',
  'item.55.desc': 'كرواسون محشو بكريمة اللوز، مغطى بشرائح اللوز والسكر البودرة.',
  'item.56.name': 'توست الأفوكادو والبيض',
  'item.56.desc': 'خبز محمص مغطى بالأفوكادو المهروس والبيض المخفوق، مع الرمان والفيتا.',
  'item.57.name': 'وعاء الغرانولا',
  'item.57.desc': 'غرانولا مقرمشة مع الزبادي والفواكه الطازجة والعسل.',
  'item.58.name': 'كرواسون عسل وفيتا',
  'item.58.desc': 'كرواسون زبداني محشو بجبنة الفيتا ومزين بالعسل.',
  'item.59.name': 'كرواسون ديك رومي مدخن وجبن',
  'item.59.desc': 'كرواسون محشو بديك رومي مدخن وجبن ذائب.',
  'item.60.name': 'كرواسون بثلاث أجبان',
  'item.60.desc': 'كرواسون زبداني مقرمش محشو بمزيج دافئ من ثلاثة أنواع من الجبن الذائب لطعم غني ولذيذ.',
  'item.61.name': 'ميلك شيك الفراولة',
  'item.61.desc': 'مشروب سميك وكريمي من الفراولة الطازجة المخلوطة مع الحليب البارد، يُقدّم مع الكريمة المخفوقة لمذاق حلو ولذيذ بنكهة الفواكه.',

  'about.title': 'مصنوع بعناية',
  'about.desc': 'في BIOLA CAFE & RESTAURANT، نؤمن أن الطعام الرائع يبدأ بمكونات رائعة. يتم تحضير كل طبق طازج يوميًا باستخدام المنتجات المحلية والخبز الحرفي ومنتجات الألبان المتميزة. من معجناتنا الهشة إلى أوعيتنا النابضة بالحياة، نسكب الشغف في كل طبق.',
  'about.fresh.title': 'مكونات طازجة',
  'about.fresh.desc': 'منتجات محلية وموسمية مختارة في أقصى درجات الطزاجة.',
  'about.love.title': 'مصنوع بحب',
  'about.love.desc': 'كل طبق مصنوع يدويًا من قبل طهاة شغوفين.',
  'about.daily.title': 'طازج يوميًا',
  'about.daily.desc': 'يُخبز ويُحضر طازجًا كل صباح.',
  'home.aboutTitle': 'مصنوع بعناية',
  'home.aboutDesc': 'في BIOLA CAFE & RESTAURANT، نؤمن أن الطعام الرائع يبدأ بمكونات رائعة. يتم تحضير كل طبق طازج يوميًا باستخدام المنتجات المحلية والخبز الحرفي ومنتجات الألبان المتميزة. من معجناتنا الهشة إلى أوعيتنا النابضة بالحياة، نسكب الشغف في كل طبق.',
  'home.aboutCta': 'تعرف على المزيد',
  'about.heroBadge': 'تأسست 2020 — أبوظبي، الإمارات',
  'about.heroTitle': 'عن بيولا',
  'about.heroSubtitle': 'مقهى ومطعم محلي فخور مكرس لتقديم قهوة استثنائية ومشروبات متميزة وتجارب طعام لا تُنسى.',
  'about.companyTitle': 'مقدمة الشركة',
  'about.companyDesc': 'BIOLA هي شركة مقهى محلية فخرية تأسست عام 2020 في أبوظبي، الإمارات العربية المتحدة. منذ بدايتنا، كنا مكرسين لتقديم تجارب قهوة استثنائية ومشروبات متميزة وأجواء مرحبة لعملائنا. على مر السنين، مكّنتنا التزامنا بالجودة والاتساق وخدمة العملاء المتميزة من التوسع بنجاح إلى ثلاثة فروع في أبوظبي.',
  'about.established': 'التأسيس',
  'about.branches': 'الفروع',
  'about.team': 'أعضاء الفريق',
  'about.menuItems': 'عناصر القائمة',
  'about.visionTitle': 'رؤيتنا',
  'about.visionDesc': 'تقديم قهوة استثنائية وتجارب عملاء لا تُنسى من خلال الجمع بين المكونات المتميزة والحرفية الماهرة والضيافة الدافئة في كل كوب نقدمه.',
  'about.missionTitle': 'مهمتنا',
  'about.missionDesc': 'أن نصبح من أكثر علامات القهوة موثوقية وشهرة في أبوظبي، معروفين بالجودة والابتكار والمشاركة المجتمعية — نقدم للعملاء طعامًا ومشروبات عالية الجودة مع الحفاظ على معايير صارمة من التميز في خدمة العملاء والسلامة الغذائية وكفاءة التشغيل.',
  'about.commitmentsTitle': 'معاييرنا',
  'about.commitmentsDesc': 'نحن ملتزمون بالحفاظ على معايير عالية في كل جانب من جوانب عملياتنا.',
  'about.commit.foodSafety': 'سلامة الغذاء',
  'about.commit.foodSafetyDesc': 'بروتوكولات سلامة غذائية صارمة وتفتيشات منتظمة لضمان أعلى المعايير.',
  'about.commit.hygiene': 'النظافة والصحة',
  'about.commit.hygieneDesc': 'ممارسات تنظيف وتعقيم صارمة يتم الحفاظ عليها في جميع العمليات.',
  'about.commit.quality': 'جودة المنتج',
  'about.commit.qualityDesc': 'مكونات متميزة وتحضير دقيق لنتائج ممتازة باستمرار.',
  'about.commit.satisfaction': 'رضا العملاء',
  'about.commit.satisfactionDesc': 'خدمة ودية ومتيقظة مصممة لتتجاوز التوقعات في كل زيارة.',
  'about.servicesTitle': 'خدماتنا',
  'about.servicesDesc': 'أكثر من مجرد تناول الطعام — حلول ضيافة كاملة لكل مناسبة.',
  'about.service.corporate': 'تموين الشركات',
  'about.service.corporateDesc': 'قوائم مخصصة للاجتماعات والمؤتمرات والفعاليات التجارية.',
  'about.service.private': 'فعاليات خاصة',
  'about.service.privateDesc': 'أعياد ميلاد ومناسبات خاصة بإعدادات شخصية.',
  'about.service.weddings': 'أعراس وخطوبات',
  'about.service.weddingsDesc': 'إعدادات أنيقة وقوائم منسقة ليومكم الخاص.',
  'about.service.social': 'التجمعات الاجتماعية',
  'about.service.socialDesc': 'مكان وخبرة طعام مثالية لأي لقاء مع الأصدقاء والعائلة.',
  'about.service.exhibitions': 'معارض ومنصات مؤقتة',
  'about.service.exhibitionsDesc': 'دعم احترافي للمعارض والمنصات المؤقتة والفعاليات الترويجية.',
  'about.service.delivery': 'الوجبات الجاهزة والتوصيل',
  'about.service.deliveryDesc': 'استمتع بوجباتك المفضلة أينما كنت مع خدمة الوجبات الجاهزة والتوصيل.',
  'about.sustainTitle': 'الاستدامة',
  'about.sustainDesc': 'في بيولا، نحن ملتزمون بممارسات مستدامة تحمي بيئتنا وتدعم مجتمعنا.',
  'about.sustain.sourcing': 'الاستدامة في التوريد',
  'about.sustain.sourcingDesc': 'نحن نحصل على مكونات محلية وموسمية لدعم المزارعين المحليين وتقليل البصمة الكربونية.',
  'about.sustain.eco': 'الممارسات الصديقة للبيئة',
  'about.sustain.ecoDesc': 'نقلل النفايات ونُعيد التدوير بمسؤولية ونستخدم عبوات صديقة للبيئة.',
  'about.sustain.community': 'دعم المجتمع',
  'about.sustain.communityDesc': 'نؤمن برد الجميل من خلال دعم المجتمعات المحلية والمبادرات الهادفة.',
  'about.ctaTitle': 'هل أنتم مستعدون لتجربة بيولا؟',
  'about.ctaDesc': 'زوروا أحد فروعنا الثلاثة في أبوظبي أو تواصلوا معنا للتموين والفعاليات.',
  'about.ctaButton': 'تواصل معنا',

  'locations.title': 'قم بزيارتنا',
  'locations.subtitle': 'تعال لتجربة الأجواء الدافئة والنكهات اللذيذة في مقهانا المريح.',
  'locations.name': 'BIOLA CAFE & RESTAURANT',
  'locations.address': 'شارع المuroor، بالقرب من الوحدة مول، أبوظبي، الإمارات العربية المتحدة',
  'locations.hours': 'الإثنين-الأحد: 9:00 ص - 9:00 م',

  'locations.pageBadge': 'ثلاثة فروع \u2022 أبوظبي',
  'locations.pageTitle': 'فروعنا',
  'locations.pageSubtitle': 'اكتشف فروعنا الثلاثة في أبوظبي واعثر على الأقرب إليك.',
  'locations.hoursLabel': 'ساعات العمل',
  'locations.getDirections': 'الاتجاهات',
  'locations.ctaTitle': 'اعثر على أقرب فرع',
  'locations.ctaDesc': 'اضغط على "الاتجاهات" لفتح الموقع الدقيق في خرائط جوجل وابدأ رحلتك نحو قهوة رائعة.',
  'locations.ctaButton': 'افتح خرائط جوجل',
  'locations.branch.1.tag': 'فرع 01',
  'locations.branch.1.name': 'بيولا كافيه (مفرق)',
  'locations.branch.1.address': 'محطة أدنوك للخدمات | مفرق (171)، بني ياس، بني ياس الشرقية، أبوظبي',
  'locations.branch.1.hours': 'الإثنين-الأحد: 9:00 ص - 9:00 م',
  'locations.branch.2.tag': 'فرع 02',
  'locations.branch.2.name': 'أوتو كافيه (بني ياس)',
  'locations.branch.2.address': 'محطة أدنوك للخدمات -114، شارع البروج، بني ياس، بني ياس الشرقية، أبوظبي',
  'locations.branch.2.hours': 'الإثنين-الأحد: 9:00 ص - 9:00 م',
  'locations.branch.3.tag': 'فرع 03',
  'locations.branch.3.name': 'أوتو كافيه (خليفة)',
  'locations.branch.3.address': 'محطة أدنوك للخدمات -523 الدار، مدينة خليفة، SE45، أبوظبي',
  'locations.branch.3.hours': 'الإثنين-الأحد: 9:00 ص - 9:00 م',

  'contact.title': 'لديك أسئلة؟',
  'contact.desc': 'تواصل معنا للحجوزات أو التموين أو فقط لقول مرحبًا. نود أن نسمع منك!',
  'contact.email': 'hello@biola.cafe',
  'contact.pageTitle': 'تواصل معنا',
  'contact.pageSubtitle': 'هل لديك سؤال أو ملاحظة أو تحتاج تمويناً؟ نود أن نسمع منك.',
  'contact.phone': 'الهاتف',
  'contact.email': 'البريد الإلكتروني',
  'contact.person': 'الشخص المسؤول',
  'contact.address': 'العنوان',
  'contact.visitTitle': 'زورونا',
  'contact.visitDesc': 'تجدونا في أحد مواقعنا الثلاثة في أبوظبي.',
  'contact.hours': 'ساعات العمل',
  'contact.hoursValue': 'الإثنين-الأحد: 9:00 ص - 9:00 م',
  'contact.formTitle': 'أرسل رسالة',
  'contact.formDesc': 'املأ النموذج أدناه وسنرد عليك في أقرب وقت ممكن.',
  'contact.form.name': 'الاسم الكامل',
  'contact.form.namePlaceholder': 'أدخل اسمك الكامل',
  'contact.form.email': 'البريد الإلكتروني',
  'contact.form.emailPlaceholder': 'أدخل بريدك الإلكتروني',
  'contact.form.subject': 'الموضوع',
  'contact.form.subjectPlaceholder': 'ما هو الموضوع؟',
  'contact.form.message': 'الرسالة',
  'contact.form.messagePlaceholder': 'أخبرنا كيف يمكننا المساعدة...',
  'contact.form.maxChars': '500 حرف كحد أقصى',
  'contact.form.send': 'إرسال الرسالة',
  'contact.form.sent': 'تم الإرسال',
  'contact.form.success': 'شكراً! تم إرسال رسالتك بنجاح.',
  'contact.form.error': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'contact.form.spamError': 'تعذر إرسال الرسالة. يرجى المحاولة لاحقاً.',

  'privacy.pageTitle': 'سياسة الخصوصية',
  'privacy.pageSubtitle': 'كيفية جمع معلوماتك واستخدامها وحمايتها.',
  'privacy.effective': 'تاريخ السريان:',
  'privacy.effectiveDate': '1 يناير 2024',
  'privacy.footer': '\u00A9 {year} BIOLA CAFE & RESTAURANT. جميع الحقوق محفوظة.',
  'privacy.introTitle': 'مقدمة',
  'privacy.introContent': 'تُلتزم BIOLA CAFE & RESTAURANT بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمعنا واستخدامنا والإفصاح عن وحماية معلوماتك عند زيارة موقعنا الإلكتروني أو استخدام خدماتنا.',
  'privacy.infoTitle': 'المعلومات التي نجمعها',
  'privacy.infoContent': 'قد نجمع معلومات شخصية تقدمها لنا طوعاً، بما في ذلك اسمك وعنوان بريدك الإلكتروني ورقم هاتفك وأي رسائل ترسلها عبر نموذج الاتصال. نجمع أيضاً معلومات غير شخصية مثل نوع المتصفح ومعلومات الجهاز وبيانات الاستخدام.',
  'privacy.useTitle': 'كيف نستخدم معلوماتك',
  'privacy.useContent': 'نستخدم المعلومات التي نجمعها للرد على استفساراتك ومعالجة طلباتك وتحسين خدماتنا والتواصل معك بشأن العروض والتحديثات وضمان أمان موقعنا.',
  'privacy.sharingTitle': 'مشاركة المعلومات والإفصاح عنها',
  'privacy.sharingContent': 'قد نشارك معلوماتك مع مزودي الخدمات الموثوقين الذين يساعدوننا في تشغيل موقعنا وإدارة أعمالنا، شريطة موافقتهم على الحفاظ على سرية هذه المعلومات.',
  'privacy.securityTitle': 'أمان البيانات',
  'privacy.securityContent': 'ننفذ إجراءات تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التعديل أو الإفصاح أو التدمير.',
  'privacy.cookiesTitle': 'ملفات تعريف الارتباط وتقنيات التتبع',
  'privacy.cookiesContent': 'قد يستخدم موقعنا ملفات تعريف الارتباط وتقنيات التتبع المشابهة لتعزيز تجربة التصفح وتحليل حركة المرور على الموقع.',
  'privacy.rightsTitle': 'حقوقك',
  'privacy.rightsContent': 'لديك الحق في الوصول إلى معلوماتك الشخصية وتصحيحها وتحديثها أو حذفها. يمكنك أيضاً الاعتراض على معالجة بياناتك الشخصية أو طلب تقييد استخدامها.',
  'privacy.changesTitle': 'التغييرات على هذه السياسة',
  'privacy.changesContent': 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. نحن نشجعك على مراجعة هذه السياسة بشكل دوري لأي تحديثات. استمرارك في استخدام موقعنا بعد أي تغييرات يشكل قبولاً للسياسة المُنقحة.',
  'privacy.contactTitle': 'تواصل معنا',
  'privacy.contactContent': 'إذا كان لديك أي أسئلة أو مخاوف أو طلبات بخصوص سياسة الخصوصية هذه أو ممارسات البيانات لدينا، يرجى التواصل معنا على biola.ae1@gmail.com أو الاتصال بنا على +971 50 446 4660.',

  'footer.rights': '\u00A9 {year} BIOLA CAFE & RESTAURANT. جميع الحقوق محفوظة. طعام طازج وأجواء دافئة.',

  'sidebar.filters': 'المرشحات',
  'filter.applyFilters': 'تطبيق الفلاتر',

  'menuTeaser.badge': 'طازج يوميًا',
  'menuTeaser.title': 'لمحة مما ينتظرك',
  'menuTeaser.desc': 'من القهوة المتخصصة المصنوعة يدويًا والمعجنات الهشة إلى الأوعية النابضة بالحياة والحلويات الفاخرة — استكشف قائمتنا الكاملة من الأطباق الطازجة والمحلية.',
  'menuTeaser.cta': 'استكشف القائمة الكاملة',

  'scan.title': 'مسح رمز QR',
  'scan.subtitle': 'استخدم الكاميرا لمسح أي رمز QR وعرض الروابط أو العروض أو القوائم الرقمية فورًا.',
  'scan.qrDesc': 'امسح رمز QR هذا بكاميرا هاتفك لعرض قائمتنا الرقمية والطلب مباشرة.',
  'scan.qrHint': 'وجّه كاميرا هاتفك نحو الرمز أعلاه واضغط على الإشعار الذي يظهر لفتح القائمة فورًا.',
  'scan.visitSite': 'زور قائمتنا',
  'scan.scannerTitle': 'ماسح الكاميرا',
  'scan.start': 'ابدأ المسح',
  'scan.stop': 'إيقاف المسح',
  'scan.ready': 'الكاميرا جاهزة',
  'scan.readyHint': 'اضغط "ابدأ المسح" ووجّه الكاميرا نحو رمز QR.',
  'scan.status.idle': 'خامل',
  'scan.status.starting': 'جارٍ البدء',
  'scan.status.scanning': 'جارٍ المسح',
  'scan.status.stopped': 'متوقف',
  'scan.status.error': 'خطأ',
  'scan.resultTitle': 'نتيجة المسح',
  'scan.detected': 'المحتوى المكتشف',
  'scan.openLink': 'فتح الرابط',
  'scan.clear': 'مسح',
  'scan.emptyResult': 'لا توجد نتيجة بعد',
  'scan.emptyHint': 'وجّه الكاميرا نحو رمز QR وسيظهر المحتوى المفكك هنا.',
  'scan.howBadge': 'كيف يعمل',
  'scan.howTitle': 'المسح في ثلاث خطوات بسيطة',
  'scan.step1.title': 'السماح بالكاميرا',
  'scan.step1.desc': 'امنح إذن الوصول للكاميرا عندما يطلب المتصفح ذلك.',
  'scan.step2.title': 'محاذاة الرمز',
  'scan.step2.desc': 'ضع رمز QR داخل الإطار للحصول على رؤية واضحة وحادة.',
  'scan.step3.title': 'احصل على النتيجة',
  'scan.step3.desc': 'يظهر الرابط أو النص المفكك فورًا في لوحة النتيجة.',
};